import { Box, Container, Image, Modal, ModalBody, ModalCloseButton, ModalContent, ModalOverlay, Text, useDisclosure } from "@chakra-ui/react";
import { landingPageConstants } from "common/landingPageConstants";
import VidThumbnail from "common/assets/img/dashDummy2.png";
import SubtitleIcon from "common/assets/img/subtitleIcon.png";
import VidSecBg from "common/assets/img/vidSecBg.png";
import dashVideo from "common/assets/video/daashboardVideo.mp4";
import VidPlayIcon from "common/assets/img/vidplayicon.png"


const VideoSection = () => {
    const { isOpen, onOpen, onClose } = useDisclosure();
  const onPreview = () => {
    onOpen();
  };
  return (
    <>
    <Box className="videMainSection" id="video">
        <Image src={VidSecBg} height="100%" className="videSecBg" width="100%" alt="" />
      <Container maxW="container.xl">
        <Box className="videoSectionAction">
          <Box className="sectionTitlebox">
           <Text className="iconSubtitle"> <Image src={SubtitleIcon} height={"16px"} width={"16px"} alt="" /> Action</Text>

            <Text className="sectionTitle">
              {landingPageConstants.videoTitle}
            </Text>
            <Text className="sectionDesc">
              {landingPageConstants.videoDesc}
            </Text>
          </Box>
          <Box className="videoBox">
            <Image src={VidThumbnail} height={"auto"} width={"100%"} className="videoThumbnailImg" alt="" />
            <Box className="vidThumbLayer">
                <Box className="playVidIcon" onClick={onPreview}>
                    <Image src={VidPlayIcon} height={"30px"} width={"30px"} alt=""/>
                </Box>
            </Box>
          </Box>
        </Box>
      </Container>
      </Box>
       <Modal onClose={onClose} size={"full"} isOpen={isOpen} className>
              <ModalOverlay />
              <ModalContent>
                <ModalCloseButton fontSize={"20px"} />
                <ModalBody display={"flex"} justifyContent={"center"}>
                  <video
                    className="videoModal"
                    controls
                    loop
                    disablePictureInPicture
                    controlsList="nofullscreen"
                  >
                    <source src={dashVideo} />
                  </video>
                </ModalBody>
              </ModalContent>
            </Modal>
    </>
  );
};
export default VideoSection;
